import React from 'react';
import { Search } from 'lucide-react';

type PageSearchBarProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  id?: string;
};

export function PageSearchBar({ value, onChange, placeholder = 'Search…', className = '', id }: PageSearchBarProps) {
  return (
    <div className={`relative max-w-md ${className}`}>
      <label htmlFor={id} className="sr-only">
        Search
      </label>
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" aria-hidden />
      <input
        id={id}
        type="search"
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-lg border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm text-slate-900 shadow-sm placeholder:text-slate-400 focus:border-emerald-500/40 focus:outline-none focus:ring-2 focus:ring-emerald-600/20"
      />
    </div>
  );
}
